module.exports = __webpack_public_path__ + "assets/img/site_wheel.85484eac.png";